// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maropost-app #default-layout[data-v-e134a4ec]:not(.legacy-app *) {
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  min-height: 100vh;
}
.maropost-app .pointer-not-allowed[data-v-e134a4ec]:not(.legacy-app *) {
  cursor: not-allowed;
}
.maropost-app .select-account-list[data-v-e134a4ec]:not(.legacy-app *) {
  max-height: 500px;
}
.maropost-app[data-v-e134a4ec] :not(.legacy-app *) .v-skeleton-loader__bone.v-skeleton-loader__list-item .v-skeleton-loader__text {
  height: 3rem !important;
}
.maropost-app[data-v-e134a4ec] :not(.legacy-app *) .v-skeleton-loader__bone.v-skeleton-loader__list-item {
  margin: 0.25rem !important;
}`, "",{"version":3,"sources":["webpack://./src/lib/components/SelectAccountPage.vue"],"names":[],"mappings":"AACC;EACC,aAAA;EACA,uBAAA,EAAA,wBAAA;EACA,mBAAA,EAAA,sBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,iBAAA;AAAF;AAEA;EACE,mBAAA;AACF;AACA;EACE,iBAAA;AAEF;AAAA;EACE,uBAAA;AAGF;AADA;EACE,0BAAA;AAIF","sourcesContent":["\n #default-layout {\n  display: flex;\n  justify-content: center; /* Center horizontally */\n  align-items: center;     /* Center vertically */\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  min-height: 100vh;\n}\n.pointer-not-allowed {\n  cursor: not-allowed;\n}\n.select-account-list {\n  max-height: 500px;\n}\n:deep(.v-skeleton-loader__bone.v-skeleton-loader__list-item .v-skeleton-loader__text) {\n  height: 3rem !important;\n}\n:deep(.v-skeleton-loader__bone.v-skeleton-loader__list-item) {\n  margin: 0.25rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
